<script setup lang="ts">
import DSButton from 'primevue/button';

// -----
// Types
// -----

type IconType = 'loading' | 'success';

interface Props {
  iconType?: IconType;
  text?: string;
  ctaLabel?: string;
  ctaMethod?: () => void;
}

// -----
// Props
// -----

const props = withDefaults(defineProps<Props>(), {
  iconType: 'loading',
  text: '',
  ctaLabel: '',
  ctaMethod: () => {},
});
</script>

<template>
  <div :class="$style.status">
    <div
      v-if="props.iconType === 'loading'"
      :class="[$style.status__icon, $style['icon-loading']]"
    ></div>
    <div
      v-if="props.iconType === 'success'"
      :class="[$style.status__icon, $style['icon-success']]"
    >
      <icon name="check" :class="$style['icon-success__mark']" />
    </div>
    <p v-if="props.text" :class="$style.status__text">{{ props.text }}</p>
    <DSButton
      v-if="props.ctaLabel"
      :class="$style.status__button"
      :label="props.ctaLabel"
      @click="props.ctaMethod"
    />
  </div>
</template>

<style lang="less" module>
.status {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

.status__icon {
  margin-bottom: 30px;
}

.status__text {
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  margin: 0;
}

.status__text + .status__button {
  margin-top: 30px;
}

.icon-loading {
  width: 80px;
  height: 80px;
  border: 4px solid #6c63ff;
  border-radius: 50%;
  animation: spin 2s linear infinite;
  position: relative;
}

.icon-loading::after {
  content: '';
  display: block;
  width: 60%;
  height: 60%;
  background: #fff;
  position: absolute;
  top: 50%;
  right: 50%;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.icon-success {
  width: 90px;
  height: 90px;
  background: #def2e7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-success__mark {
  width: 36px;
  height: 36px;
  font-size: 18px;
  padding: 10px;
  background: #23aa71;
  border-radius: 50%;
  color: #fff;
}
</style>
